import {BackendUserOffDatePlanService} from '@common/api';
import {Button} from 'antd';
import {CommonManager} from 'components/Common/Manager';
import {CommonTable} from 'components/Common/Table';
import {useApi} from 'hooks/useApi';
import {genRequest} from 'libs/genRequest';
import {
  BackendOrderAccept,
  BackendOrderCancel,
  BackendOrderDelete,
} from './Actions';

const ExportExcel: React.FC<any> = ({params, columns = [], sort}) => {
  const downloadExcel = useApi(BackendUserOffDatePlanService.exportExcel);
  return (
    <Button
      onClick={async () => {
        const res = await downloadExcel({
          requestBody: {
            where: params,
            keyword: params.keyword,
            sortKey: params.sortKey,
            sortType: params.sortType,
            columns,
          },
        });
        console.log(res);
      }}
    >
      匯出Excel
    </Button>
  );
};

export const BackendOffDateOrderManager = () => {
  const findAll = useApi(BackendUserOffDatePlanService.findAll);
  return (
    <CommonManager
      request={genRequest(findAll)}
      headerActions={[ExportExcel]}
      rowActions={row => {
        if (row.status === 'CREATE') {
          return [BackendOrderAccept, BackendOrderCancel];
        }

        return [BackendOrderDelete];
      }}
      params={{
        sortKey: 'id',
        sortType: 'DESC',
      }}
      search={{}}
      columns={[
        CommonTable.Utils.Sorter({
          title: '使用者帳號',
          dataIndex: ['user', 'username'],
          hideInSearch: true,
        }),
        CommonTable.Utils.Sorter({
          title: '使用者暱稱',
          dataIndex: ['user', 'nickname'],
          hideInSearch: true,
        }),
        CommonTable.Utils.Sorter({
          title: '購買日期',
          dataIndex: 'createdAt',
          valueType: 'date',
          hideInSearch: false,
        }),
        CommonTable.Utils.Sorter({
          title: '付款狀態',
          dataIndex: 'status',
          valueEnum: {
            CREATE: '等待付款(已建立訂單)',
            RECEIVE1: '等待付款(等待使用者付費)',
            RECEIVE2: '已完成',
            CANCEL: '取消訂單',
          },
          valueType: 'select',
        }),
        CommonTable.Utils.Sorter({
          title: '購買方案',
          dataIndex: ['orderItem'],
          hideInSearch: true,
        }),
        CommonTable.Utils.Sorter({
          title: '購買金額',
          dataIndex: 'amount',
          hideInSearch: true,
        }),
      ]}
    />
  );
};
